<button
  type="button"
  class="btn btn-outline-primary d-flex align-items-center history-log-btn px-2"
  (click)="openDrawer()"
  ngbTooltip="View the history of bulk pricing updates and reverts."
  container="body"
  placement="bottom"
>
  <i class="feather icon-clock mr-1"></i>
  <span>History Logs</span>
</button>

<!-- Side Drawer -->
<div class="history-log-drawer" [class.show]="isOpened">
  <!-- Backdrop / Overlay -->
  <div class="drawer-overlay" (click)="closeDrawer()"></div>

  <!-- Drawer Container -->
  <div class="drawer-container">
    <div class="drawer-header">
      <div class="d-flex align-items-center">
        <i class="feather icon-list mr-2 text-primary"></i>
        <div>
          <h6 class="mb-0">History Logs</h6>
        </div>
      </div>
      <button type="button" class="close-btn" (click)="closeDrawer()">
        <i class="feather icon-x"></i>
      </button>
    </div>

    <div class="drawer-filters">
      <div class="filter-row mb-3">
        <div class="filter-item flex-grow-1">
          <label>Search Actor</label>
          <input
            type="text"
            class="form-control"
            placeholder="Search by user..."
            [(ngModel)]="actorFilter"
            (input)="onActorFilterChange()"
          />
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-item flex-grow-1">
          <label>Status</label>
          <kendo-multiselect
            [data]="statusOptions"
            textField="text"
            valueField="value"
            [(ngModel)]="selectedStatuses"
            [tagMapper]="tagMapper"
            (valueChange)="onStatusChange()"
            [checkboxes]="true"
            [autoClose]="false"
            placeholder="Filter by Status..."
          >
          </kendo-multiselect>
        </div>

        <div class="filter-item flex-shrink-0">
          <label class="filter-label">DATE RANGE</label>
          <app-date-range-selection
            [value]="range"
            (valueChange)="onDateRangeChange($event)"
          ></app-date-range-selection>
        </div>
      </div>
    </div>

    <div class="drawer-body">
      <!-- Loading -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading history...</span>
        </div>
      </div>

      <!-- Log List -->
      <div class="log-list" *ngIf="!loading && jobs.length > 0">
        <div
          class="log-item"
          *ngFor="let job of jobs"
          [class.is-revert]="job.isRevert"
          [class.completed]="job.status === 'COMPLETED'"
          [class.failed]="job.status === 'FAILED'"
          [class.pending]="job.status === 'IN_PROGRESS' || job.status === 'PENDING'"
          (click)="openDetailModal(job)"
          style="cursor: pointer;"
        >
          <div class="log-dot"></div>
          <div class="log-card">
            <!-- ── Header: author + action badge ── -->
            <div class="card-row header-row">
              <div class="user-info">
                <ng-container *ngIf="job.isRevert; else normalIcon">
                  <i class="fas fa-undo text-warning"></i>
                </ng-container>
                <ng-template #normalIcon>
                  <i class="feather icon-user"></i>
                </ng-template>
                <span>{{ job.actorLabel }}</span>
              </div>
              <span class="type-badge"
                [class.type-applied]="!job.isRevert && job.status === 'COMPLETED' && !isJobReverted(job)"
                [class.type-superseded]="!job.isRevert && isJobReverted(job)"
                [class.type-reverted]="job.isRevert && job.status === 'COMPLETED'"
                [class.type-inprogress]="job.status === 'IN_PROGRESS' || job.status === 'PENDING'"
                [class.type-failed]="job.status === 'FAILED'">
                <i class="feather icon-check-circle" *ngIf="job.status === 'COMPLETED' && !job.isRevert"></i>
                <i class="feather icon-rotate-ccw" *ngIf="job.status === 'COMPLETED' && job.isRevert"></i>
                <i class="fa fa-circle-o-notch fa-spin" *ngIf="job.status === 'IN_PROGRESS' || job.status === 'PENDING'"></i>
                <i class="feather icon-alert-circle" *ngIf="job.status === 'FAILED'"></i>
                {{ job.status === 'IN_PROGRESS' || job.status === 'PENDING'
                  ? (job.isRevert ? 'Reverting...' : 'Applying...')
                  : job.status === 'FAILED'
                    ? (job.isRevert ? 'Revert Failed' : 'Failed')
                    : (job.isRevert ? 'Reverted' : 'Applied') }}
              </span>
            </div>

            <!-- ── Meta: date + log ID ── -->
            <div class="card-row meta-row">
              <div class="meta-left">
                <i class="far fa-clock"></i>
                <span class="timestamp">{{ (job.startedAt || job.createdAt) | date: "M/d/yyyy hh:mm a" }}</span>
              </div>
              <span class="log-id">#{{ job.jobBatchId.slice(-8) }}</span>
            </div>

            <!-- ── Stats: items / increases / decreases ── -->
            <div class="card-row stats-row">
              <span class="stat-chip stat-chip-total">
                <i class="feather icon-package"></i>
                {{ job.totalCount }} SKU(s)
              </span>
              
              <span class="stat-sep">·</span>
              <span class="stat-chip stat-chip-applied">
                <i class="feather icon-check-circle"></i>
                {{ job.doneCount }} applied
              </span>

              <ng-container *ngIf="job.failedCount > 0 || job.invalidCount > 0">
                <span class="stat-sep">·</span>
                <span class="stat-chip stat-chip-failed">
                  <i class="feather icon-alert-circle"></i>
                  {{ job.failedCount + job.invalidCount }} failed
                </span>
              </ng-container>

              <!-- Directional Stats (if available) -->
              <ng-container *ngIf="job.increasesCount != null">
                <span class="stat-sep">·</span>
                <span class="stat-chip stat-chip-applied">
                  <i class="feather icon-arrow-up"></i>
                  {{ job.increasesCount }}
                </span>
                <span class="stat-sep">·</span>
                <span class="stat-chip stat-chip-failed">
                  <i class="feather icon-arrow-down"></i>
                  {{ job.decreasesCount }}
                </span>
              </ng-container>

              <span class="revert-source" *ngIf="job.isRevert && job.originalJobBatchId">
                <i class="fas fa-link"></i>
                from #{{ job.originalJobBatchId.slice(-8) }}
              </span>
            </div>

            <!-- ── Footer: status + actions ── -->
            <div class="card-footer">
              <span class="status-chip status-failed"
                *ngIf="job.status === 'FAILED'">
                <i class="feather icon-alert-circle"></i>
                Failed
              </span>
              <div class="card-footer-actions" (click)="$event.stopPropagation()">
                <ng-container *ngIf="!job.isRevert">
                  <button
                    *ngIf="isJobReverted(job)"
                    class="btn btn-action-mini btn-action-reverted"
                    disabled
                  >
                    <i class="feather icon-check mr-1"></i> Reverted
                  </button>
                  <button
                    *ngIf="isJobReverting(job)"
                    class="btn btn-action-mini btn-action-reverting"
                    disabled
                  >
                    <i class="fa fa-circle-o-notch fa-spin mr-1"></i> Reverting...
                  </button>
                  <button
                    *ngIf="isPendingRevert(job)"
                    class="btn btn-action-mini btn-action-pending-revert"
                    disabled
                  >
                    <i class="feather icon-clock mr-1"></i> Revert Scheduled
                  </button>
                  <button
                    *ngIf="canRevert(job)"
                    class="btn btn-action-mini btn-action-revert"
                    (click)="onRevert($event, job)"
                  >
                    <i class="feather icon-rotate-ccw mr-1"></i> Revert
                  </button>
                </ng-container>
                  <button
                    *ngIf="canRetryRevert(job)"
                    class="btn btn-action-mini btn-action-revert"
                    (click)="onRevert($event, job)"
                  >
                    <i class="feather icon-refresh-cw mr-1"></i> Retry Revert
                  </button>
	              </div>
	            </div>
          </div>
        </div>
      </div>

      <!-- No Logs State -->
      <div class="no-logs" *ngIf="!loading && jobs.length === 0">
        <div class="text-center py-5">
          <i class="feather icon-inbox text-muted mb-2" style="font-size: 2rem;"></i>
          <p class="text-muted">No history logs found for the selected filters.</p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="drawer-pagination d-flex justify-content-between align-items-center px-4" *ngIf="totalPages > 1">
      <button class="btn btn-sm btn-outline-secondary" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
        <i class="feather icon-chevron-left"></i> Prev
      </button>

      <div class="d-flex align-items-center" style="gap: 5px;">
        <ng-container *ngFor="let p of pages; let i = index">
          <span *ngIf="i > 0 && pages[i - 1] !== p - 1" class="text-muted mx-1">...</span>
          <button
            class="btn btn-sm"
            [class.btn-primary]="p === currentPage"
            [class.btn-outline-secondary]="p !== currentPage"
            (click)="goToPage(p)"
          >
            {{ p }}
          </button>
        </ng-container>
      </div>

      <button class="btn btn-sm btn-outline-secondary" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
        Next <i class="feather icon-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
